import DOMPurify from "dompurify"

/**
 * Cleans tenant-written HTML (privacy policy, terms) before it is rendered with
 * dangerouslySetInnerHTML. Formatting is kept; scripts, event handlers,
 * javascript: links, iframes, forms and similar are removed.
 */
const LEGAL_PAGE_CONFIG = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ["style", "iframe", "frame", "object", "embed", "form", "input", "button", "textarea", "select"],
  FORBID_ATTR: ["srcset"],
  ADD_ATTR: ["target"],
}

// Links that open a new tab must not give the new page access to window.opener.
DOMPurify.addHook("afterSanitizeAttributes", node => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer")
  }
})

export const sanitizeLegalHtml = html => DOMPurify.sanitize(String(html || ""), LEGAL_PAGE_CONFIG)

/** Escapes text so it is shown as-is, never parsed as HTML. */
export const escapeHtml = text =>
  String(text ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
